<template>
  <div class="auth-container">
    <div class="auth-card">
      <div class="auth-header">
        <h1>Change Password</h1>
        <p v-if="mustChange">You must change your password before continuing</p>
        <p v-else>Update your password</p>
      </div>
      
      <form @submit.prevent="handleChangePassword" class="auth-form">
        <div v-if="!mustChange" class="form-group">
          <label for="currentPassword">Current Password</label>
          <input
            id="currentPassword"
            v-model="currentPassword"
            type="password"
            placeholder="••••••••"
            required
          />
        </div>
        
        <div class="form-group">
          <label for="newPassword">New Password</label>
          <input
            id="newPassword"
            v-model="newPassword"
            type="password"
            placeholder="At least 8 characters"
            required
            minlength="8"
            autofocus
          />
        </div>
        
        <div class="form-group">
          <label for="confirmPassword">Confirm New Password</label>
          <input
            id="confirmPassword"
            v-model="confirmPassword"
            type="password"
            placeholder="••••••••"
            required
          />
        </div>
        
        <div v-if="error" class="error-message">
          {{ error }}
        </div>
        
        <div v-if="success" class="success-message">
          {{ success }}
        </div>
        
        <button type="submit" class="btn-primary" :disabled="loading">
          {{ loading ? 'Changing...' : 'Change Password' }}
        </button>
        
        <button v-if="!mustChange" type="button" class="btn-secondary" @click="$router.push('/stations')">
          Cancel
        </button>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChangePasswordView',
  data() {
    return {
      currentPassword: '',
      newPassword: '',
      confirmPassword: '',
      error: null,
      success: null,
      loading: false
    }
  },
  computed: {
    mustChange() {
      return this.$store.getters['auth/user']?.mustChangePassword
    }
  },
  methods: {
    async handleChangePassword() {
      if (this.newPassword !== this.confirmPassword) {
        this.error = 'Passwords do not match'
        return
      }
      
      if (this.newPassword.length < 8) {
        this.error = 'Password must be at least 8 characters'
        return
      }
      
      this.error = null
      this.success = null
      this.loading = true
      
      try {
        await this.$store.dispatch('auth/changePassword', {
          currentPassword: this.mustChange ? null : this.currentPassword,
          newPassword: this.newPassword
        })
        
        this.success = 'Password changed successfully'
        
        setTimeout(() => {
          this.$router.push('/stations')
        }, 1500)
      } catch (err) {
        this.error = err.message
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.auth-container {
  min-height: calc(100vh - 74px);
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--gray-100);
  padding: 20px;
}

.auth-card {
  background: var(--white);
  border-radius: 12px;
  box-shadow: var(--shadow-md);
  padding: 40px;
  width: 100%;
  max-width: 400px;
}

.auth-header {
  text-align: center;
  margin-bottom: 32px;
}

.auth-header h1 {
  font-size: 24px;
  font-weight: 600;
  color: var(--gray-900);
  margin: 0 0 8px 0;
}

.auth-header p {
  font-size: 14px;
  color: var(--gray-500);
  margin: 0;
}

.auth-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-group label {
  font-size: 14px;
  font-weight: 500;
  color: var(--gray-700);
}

.form-group input {
  padding: 10px 12px;
  border: 1px solid var(--gray-200);
  border-radius: 6px;
  font-size: 14px;
  transition: border-color 0.15s, box-shadow 0.15s;
}

.form-group input:focus {
  outline: none;
  border-color: var(--gray-400);
  box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.05);
}

.error-message {
  background: #fef2f2;
  color: #dc2626;
  padding: 10px 12px;
  border-radius: 6px;
  font-size: 14px;
}

.success-message {
  background: #f0fdf4;
  color: #16a34a;
  padding: 10px 12px;
  border-radius: 6px;
  font-size: 14px;
}

.btn-primary {
  padding: 12px;
  background: var(--accent);
  color: var(--white);
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s;
}

.btn-primary:hover:not(:disabled) {
  background: var(--accent-hover);
}

.btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-secondary {
  padding: 12px;
  background: var(--white);
  color: var(--gray-700);
  border: 1px solid var(--gray-200);
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s;
}

.btn-secondary:hover {
  background: var(--gray-50);
}
</style>
